var _circle, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#paint0_linear_932_1048)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2402 24.9554C25.2402 25.6529 25.434 25.7562 25.8732 25.9112L26.5319 26.1437V23.9479H26.1444C25.6536 23.9479 25.2402 24.4 25.2402 24.9554Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4688 31.052H28.8563C29.36 31.052 29.7604 30.6 29.7604 30.0445C29.7604 29.347 29.5667 29.2437 29.1275 29.0887L28.4688 28.8562V31.052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2915 19.0784L34.6436 21.7263C34.4498 21.92 34.2044 22.0105 33.959 22.0105C33.7136 22.0105 33.4682 21.92 33.2744 21.7263C32.8998 21.3517 32.8998 20.7317 33.2744 20.3571L35.9223 17.7092C33.649 15.7717 30.7169 14.5834 27.5007 14.5834C20.3707 14.5834 14.584 20.37 14.584 27.5C14.584 34.63 20.3707 40.4167 27.5007 40.4167C34.6307 40.4167 40.4173 34.63 40.4173 27.5C40.4173 24.2838 39.229 21.3517 37.2915 19.0784ZM29.7611 27.2675C30.5877 27.5646 31.6986 28.1588 31.6986 30.0575C31.6986 31.6721 30.4198 33.0025 28.8569 33.0025H28.4694V33.3255C28.4694 33.855 28.0302 34.2942 27.5007 34.2942C26.9711 34.2942 26.5319 33.855 26.5319 33.3255V33.0025H26.4286C24.7107 33.0025 23.3027 31.5559 23.3027 29.7734C23.3027 29.2309 23.7419 28.7917 24.2715 28.7917C24.8011 28.7917 25.2402 29.2309 25.2402 29.7605C25.2402 30.4709 25.7698 31.0521 26.4286 31.0521H26.5319V28.1846L25.2402 27.7325C24.4136 27.4355 23.3027 26.8413 23.3027 24.9425C23.3027 23.328 24.5815 21.9975 26.1444 21.9975H26.5319V21.6875C26.5319 21.158 26.9711 20.7188 27.5007 20.7188C28.0302 20.7188 28.4694 21.158 28.4694 21.6875V22.0105H28.5727C30.2907 22.0105 31.6986 23.4571 31.6986 25.2396C31.6986 25.7692 31.2594 26.2084 30.7298 26.2084C30.2002 26.2084 29.7611 25.7692 29.7611 25.2396C29.7611 24.5292 29.2315 23.948 28.5727 23.948H28.4694V26.8155L29.7611 27.2675Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3079 14.2088C41.2046 13.9763 41.0238 13.7825 40.7783 13.6792C40.6621 13.6405 40.5458 13.6146 40.4167 13.6146H35.25C34.7204 13.6146 34.2812 14.0538 34.2812 14.5834C34.2812 15.113 34.7204 15.5521 35.25 15.5521H38.0788L35.9217 17.7092C36.4125 18.1355 36.8646 18.5875 37.2908 19.0784L39.4479 16.9213V19.75C39.4479 20.2796 39.8871 20.7188 40.4167 20.7188C40.9462 20.7188 41.3854 20.2796 41.3854 19.75V14.5834C41.3854 14.4542 41.3596 14.338 41.3079 14.2088Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_1048",
    x1: 11.5,
    y1: 59,
    x2: 37.5731,
    y2: 6.4615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544463"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508486,
    stopColor: "#9F533B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6403"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon_dollar.29715aacfbe044c00df050533704dda0.svg";
export { ForwardRef as ReactComponent };